const itpAgeThresholdLower = 25;
const itpAgeThresholdUpper = 65;
const itpRateDefault = 0.045;

export default {
  itpAgeThresholdLower,
  itpAgeThresholdUpper,
  itpRateDefault
};



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/user/settings-constants.js
 **/